export const FETCHING = "FETCHING";
export const ERROR = "ERROR";
export const IDLE = "IDLE";
export const DELIVERY_EATIN = "EATIN";
export const DELIVERY_TAKEAWAY = "TAKEAWAY";
